// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2pQq6","header":"MessagesList_header__m-ZiQ","chat":"MessagesList_chat__sbuRy"};